import JwtDecode from 'jwt-decode'

export default class User {
  static from (token) {
    try {
      let obj = JwtDecode(token)
      return new User(obj)
    } catch (_) {
      return null
    }
  }

  constructor ({ user_id, role, email }) {
    this.id = user_id // eslint-disable-line camelcase
    this.role = role
    this.email = email
  }

  get isAdmin () {
    return this.role
  }
}



// WEBPACK FOOTER //
// ./src/models/User.js